/**
 * QuotationLineService
 * Service for QuotationLine entity operations
 * Route: api/quotationline
 * Controller: QuotationLineController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * QuotationLineService
 * Handles quotation line CRUD operations
 * Maps to /api/quotationline endpoint
 */
export class QuotationLineService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? QuotationLineService.DEFAULT_SERVICE_PATH,
            basePath: QuotationLineService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
QuotationLineService.DEFAULT_SERVICE_PATH = 'procurements';
QuotationLineService.BASE_PATH = 'api/quotationline';
//# sourceMappingURL=QuotationLineService.js.map